import { DateTime } from 'luxon'

export const isDateRangeValid = (initial: DateTime | null, final: DateTime | null) => {
  return final && initial && initial <= final
}

export const isFutureDate = (date: DateTime | null) => date && date > DateTime.now()
